import * as React from "react"
import { Box, Typography } from "@mui/material"
import { IconSeeker, TooltipSeeker } from "@ui-seeker/core"
import TableTitle from "./TableTitle";


export default function PriceEvolutionWidgetTooltip({ data=[], label, value, showIcon, fontSize='1rem', isPercentage, color }) {
	return <TooltipSeeker
		title={!data || !data.length ? null : <TableTitle data={data} isPercentage={isPercentage} />}
		sx={{
			background: 'linear-gradient(110deg, rgba(210,210,210,1) 0%, rgba(230,230,230,1) 100%)',
			boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, .1), 0px 6px 10px 0px rgba(0, 0, 0, .03), 0px 1px 18px 0px rgba(0, 0, 0, .03), 0px 1px 18px 0px rgba(0, 0, 0, .03)'
		}}
	>
		<Box sx={{ background: 'none', display: 'flex' }}>
			<Typography variant="body2" sx={{ fontSize: '0.675rem', pr: .5 }}>
				{label}
			</Typography>
			<Typography variant="subtitle2" sx={{ fontSize, color }}>
				{showIcon && <IconSeeker icon='angles-down' sx={{ pr: 1 }} />}
				{value}
			</Typography>
		</Box>
	</TooltipSeeker>
}